export default __webpack_public_path__ + "static/media/search-banner.76b4d355.png";